import { AccountsApi, MessagesApi } from "@sb1finans/banking-api/dist/api";
import axios from "axios";
import { setupAxiosInterceptors } from "./api/setupAxiosInterceptors";
import { appConfig } from "./appConfig";

const axiosInstance = axios.create({
    baseURL: appConfig.apiBaseUrl,
    timeout: 10000,
    withCredentials: false
})
setupAxiosInterceptors(axiosInstance)

export const accountsApi = new AccountsApi(undefined, appConfig.apiBaseUrl, axiosInstance)
export const invoiceApi = new AccountsApi(undefined, appConfig.apiBaseUrl, axiosInstance)
export const messagesApi = new MessagesApi(undefined, appConfig.apiBaseUrl, axiosInstance)